import React from "react";

const DetailItem = ({label, value, onMouseOver}) =>
  <div onMouseOver={onMouseOver} className="DetailItem">
    <div className="DetailLabel">{label}</div>
    <div className="DetailValue">{value}</div>
  </div>
export default DetailItem;



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/DetailItem.js